import React from 'react';
import { UserInteractionVariant } from '@naf/user-interaction';
import { SanityBlock } from '@dtp/membership-service-types/dist/sanity/sanity';
import BlockContent from '../../../../BlockContent';
import * as S from './styles';

interface InfoMessageBoxProps {
  value: {
    text: SanityBlock[];
  };
}

export const InfoMessageBox = ({ value: { text } }: InfoMessageBoxProps) => (
  <S.StyledUserInteraction variant={UserInteractionVariant.Info}>
    <S.BlockContentContainer>
      <BlockContent value={text} />
    </S.BlockContentContainer>
  </S.StyledUserInteraction>
);

export const InfoMessageBoxSerializer =
  () =>
  ({ value }: InfoMessageBoxProps) => <InfoMessageBox value={value} />;
